import React, { useCallback } from 'react';
import { ShiftCalendar } from '../types/shift-assignment.types';

interface QuickShiftSelectorProps {
    onSelectShift: (shiftId: string) => void;
    onClose: () => void;
    shifts: ShiftCalendar[];
    isLoading: boolean;
}

const QuickShiftSelector: React.FC<QuickShiftSelectorProps> = ({
    onSelectShift,
    onClose,
    shifts,
    isLoading
}) => {

    const handleSelection = useCallback((id: string) => {
        onSelectShift(id);
        onClose();
    }, [onSelectShift, onClose]);

    const getShiftLabel = (shift: ShiftCalendar) => {
        if (shift.code === 'OFF' || shift.start_time === '00:00') {
            return shift.name;
        }
        return `${shift.name} (${shift.start_time}-${shift.end_time})`;
    }

    return (
        <div className="w-full bg-white border border-gray-300 rounded-lg shadow-lg">
            {isLoading && (
                <div className="p-4 text-center text-gray-500 text-sm">Đang tải danh sách ca...</div>
            )}

            {!isLoading && shifts.length === 0 && (
                <div className="p-4 text-center text-red-500 text-sm">Không tìm thấy ca nào.</div>
            )}

            {!isLoading && shifts.map(shift => (
                <button
                    key={shift.id}
                    onClick={() => handleSelection(shift.id)}
                    className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 text-left"
                >
                    {getShiftLabel(shift)}
                </button>
            ))}
        </div>
    );
};

export default React.memo(QuickShiftSelector);